export const HomepageSliceConstants = {
  GetUsefulResources: 'getUsefulResources',
  GetRegions: 'getRegions',
  GetUsefulResourcesLink: 'getUsefulResourcesLink',
};
